// extracted by mini-css-extract-plugin
export default {"socialMedia":"footer_socialMedia__RMvxa","linkedIn":"footer_linkedIn__YOjgJ","footerLayout":"footer_footerLayout__ZjyJN","instagram":"footer_instagram__6LMCd"};